module.exports = __webpack_public_path__ + "static/Maira-Lopez-b414fbad6d80851bb56059d057ef0246.png";